module.exports = __webpack_public_path__ + "static/media/programa_publico_Alberto_Perea.5c0a450d.jpg";